<template>
    <div class="base">
        
        <h2 :style="{ marginBottom: '16px' }">
            基本设置
        </h2>
        <a-list item-layout="horizontal">
            <a-list-item>
                <a-list-item-meta :description="userinfo.company">
                    <a slot="title" href="javascript:;">公司名称</a>
                </a-list-item-meta>
            </a-list-item>
            <a-list-item>
                <a slot="actions" @click="setdomainshow($event)" :id="userinfo.id">设置</a>
                <a-list-item-meta :description="domain==''?'暂无设置':domain">
                    <a slot="title" href="javascript:;">站点域名</a>
                </a-list-item-meta>
            </a-list-item>
            <a-list-item>
                <a-list-item-meta :description="userinfo.username">
                    <a slot="title" href="javascript:;">登录账号</a>
                </a-list-item-meta>
            </a-list-item>

        </a-list>

        <a-modal
        class="pwdmodal"
        title="设置域名"
        cancelText="取消"
        okText="确定"
        width="600px"
        :visible="pwdmodal"
        :confirm-loading="confirmLoading"
        @ok="setdomain"
        @cancel="handleCancel"
        >
             <a-row>
                <a-col :span="5">
                    <label class="required-icon">站点名称：</label>
                </a-col>
                <a-col :span="16">
                   <a-input  v-model="name" placeholder="请输入站点名称"></a-input>
                </a-col>
            </a-row>
            <a-row>
                <a-col :span="5">
                    <label class="required-icon">站点域名：</label>
                </a-col>
                <a-col :span="16">
                   <a-textarea placeholder="请输入站点域名（一行一个，回车换行）" :rows="4" v-model="domain"/>
                </a-col>
            </a-row>
        </a-modal>
    </div>
</template>
<script>
export default {
    data(){
        return{
            userinfo:"",
            domain:"",
            pwdmodal:false,
            confirmLoading:false,
            id:"",
            name:""
        }
    },
    mounted(){
        this.$axios.get('/api/getuserself',{
            headers:{
                "appid": this.appSet.appid,
                "appkey": this.appSet.appkey,
                "token":localStorage.getItem('token'),
            },
            }).then((res)=> {
            if(res.data.code==200){
                this.userinfo=res.data.data
            }
        })

        this.$axios.get('/api/domainsetting',{
            headers:{
                "appid": this.appSet.appid,
                "appkey": this.appSet.appkey,
                "token":localStorage.getItem('token'),
            },
            }).then((res)=> {
            if(res.data.code==200){
                // if()
                this.domain=res.data.data.domain
                this.name=res.data.data.name
                
            }
        })
    },
    methods:{
        handleCancel(){
            this.pwdmodal=false
        },
        setdomainshow(event){
            var id=event.currentTarget.id
            this.id=id
            this.pwdmodal=true
            this.$axios.get('/api/domainsetting',{
                headers:{
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                },
                }).then((res)=> {
                if(res.data.code==200){
                    // if()
                    this.domain=res.data.data.domain
                    this.name=res.data.data.name
                    
                }
            })
        },
        setdomain(event){
            var params=new URLSearchParams()
            params.append('user_id',this.id)
            params.append('name',this.name)
            params.append('domain',this.domain)
              this.$axios.post('/api/setdomain',params,{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.$message.success('设置成功'); 
                    this.pwdmodal=false
                    this.$axios.get('/api/domainsetting',{
                        headers:{
                            "appid": this.appSet.appid,
                            "appkey": this.appSet.appkey,
                            "token":localStorage.getItem('token'),
                        },
                        }).then((res)=> {
                        if(res.data.code==200){
                            // if()
                            this.domain=res.data.data
                            
                        }
                    })
                }else{
                    this.$message.warning(res.data.msg); 
                }
            })
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/components/system/base/index.vue